import { render, staticRenderFns } from "./deliveriedOrder.vue?vue&type=template&id=9aa13a9a&"
import script from "./deliveriedOrder.vue?vue&type=script&lang=js&"
export * from "./deliveriedOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports